import { render, staticRenderFns } from "./MenuFiscalizador.vue?vue&type=template&id=7c8854d0&scoped=true&"
import script from "./MenuFiscalizador.vue?vue&type=script&lang=js&"
export * from "./MenuFiscalizador.vue?vue&type=script&lang=js&"
import style0 from "./MenuFiscalizador.vue?vue&type=style&index=0&id=7c8854d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8854d0",
  null
  
)

export default component.exports